function Validator_form(element) {
  this.$element = $(element);
	this.initialized = false;
	this.dataValidateOnSubmit = false;

	this.selectors = {
		validatorElements: '[data-i4-decorator^="Validator_"]',
		buttonSubmit: 'button[type="submit"]'
	};

	this.data = {
		submitAjax: 'submit-ajax',
		focus: 'focus',
		focusFirst: 'focus-first',
		validateOnSubmit: 'validate-on-submit',
		optionalHint: 'optional-hint',
		requiredHint: 'required-hint'
	};

	this.triggers = {
		validate: 'i4:validate',
		updateView: 'i4:updateView',
		afterLoaded: 'i4:afterLoaded',
		beforeSubmit: 'i4:beforeSubmit',
		submitAjaxSuccess: 'i4:submitAjaxSuccess',
		refresh: 'i4:refresh'
	};

	this.classNames = {
		valid: 'valid',
		invalid: 'invalid',
		disabled: 'disabled'
	};

	this.init = function () {
		// console.log('init form');

		this.dataSubmitAjax = this.$element.data(this.data.submitAjax);
		this.dataFocus = this.$element.data(this.data.focus);
		this.dataFocusFirst = this.$element.data(this.data.focusFirst);
		this.dataValidateOnSubmit = this.$element.data(this.data.validateOnSubmit);
		this.dataOptionalHint = this.$element.data(this.data.optionalHint);
		this.dataRequiredHint = this.$element.data(this.data.requiredHint);

		this.$validatorElements = this.$element.find(this.selectors.validatorElements);
		this.$buttonSubmit = this.$element.find(this.selectors.buttonSubmit);

		if (this.dataFocus) {
			this.$focusElement = this.$element.find('[name="' + this.dataFocus + '"]');
		} else if (this.dataFocusFirst) {
			this.$focusElement = this.$validatorElements.first();
		}

		if (this.dataOptionalHint) {
			this.addOptionalHintToLabels();
		}

		if (this.dataRequiredHint) {
			this.addRequiredHintToLabels();
		}

		this.sync();
		this.$element.on(this.triggers.updateView, this.updateView.bind(this));
		this.$element.on(this.triggers.refresh, this.refresh.bind(this));
	};

	this.sync = function () {
		this.updateView();

		if (this.$focusElement) {
			this.$focusElement.focus();
		}

		this.$element.trigger(this.triggers.afterLoaded);

		this.initialized = true;
	};

	this.validate = function () {
		this.formIsValid = true;
		this.$validatorElements.each((function (i, item) {
      var $item = $(item);

			if (!$item.hasClass(this.classNames.disabled) && $item.hasClass(this.classNames.invalid)) {
				this.formIsValid = false;
				return false;
			}
		}).bind(this));
	};

	this.updateView = function () {

		if (!this.dataValidateOnSubmit) {
			this.validate();

			this.$buttonSubmit.removeClass(this.classNames.invalid);
			if (!this.formIsValid) {
				this.$buttonSubmit.addClass(this.classNames.invalid);
			}
		}

		this.$element[0].onsubmit = (function () {

			if (this.dataValidateOnSubmit) {
				this.$validatorElements.trigger(this.triggers.validate);
				this.validate();

				if (!this.formIsValid) {
					var $firstInvalidField = this.$validatorElements.get().find(function(element) {
						return $(element).hasClass('invalid');
					});
					$firstInvalidField.focus();
				} else {}
			}

			if (!this.dataValidateOnSubmit || (this.dataValidateOnSubmit && this.formIsValid)) {
				this.$element.trigger(this.triggers.beforeSubmit);
			}

			if (this.dataSubmitAjax) {

				if (!this.dataValidateOnSubmit || (this.dataValidateOnSubmit && this.formIsValid)) {
					i4_Ajax.factory().
						set_parameter(this.$element.serialize()).
						set_option({
							on_complete: (function (responseText, responseJSON) {
								this.$element.trigger(this.triggers.submitAjaxSuccess, [responseJSON, this]);
							}).bind(this)
						}).
						run();
				}

				return false;

			} else {
				if (this.formIsValid) {
					return true;
				} else {
					return false;
				}
			}

		}).bind(this);
	};

	this.refresh = function () {
		if (this.initialized) {
			this.$validatorElements = this.$element.find(this.selectors.validatorElements);
			this.updateView();
		}
	};

	this.addOptionalHintToLabels = function () {
		var validatorElements = this.$validatorElements.get();

		var optionalElements = validatorElements.filter(function(item) {
			// remove required elements
			if (parseInt(item.getAttribute('data-required')) !== 0) {
				return false;
			}

			// remove list elements (checkbox, radio)
			var $item = $(item);
			var parentUL = $item.parents('ul').get(0);
			if (parentUL !== undefined && validatorElements.indexOf(parentUL) > -1) {
				return false;
			}

			return true;
		});

		optionalElements.forEach(function(element) {
			var labelElement = document.querySelector('[for='+element.getAttribute('id')+']');
			var optionalElement = document.createElement("span");
			optionalElement.innerHTML = 'Optional';
			optionalElement.className = 'optional';
			labelElement.appendChild(optionalElement);
		});

	};

	this.addRequiredHintToLabels = function() {
	  var requiredElements = document.querySelectorAll("[data-required = '1']");
	  for (let i = 0; i < requiredElements.length; i++) {
	    var labelElement = document.querySelector('[for=' + requiredElements[i].getAttribute('id') + ']');
	    var element = document.createElement("span");
	    element.innerHTML = '*';
	    element.className = "required";
      labelElement.appendChild(element);
    }
  };
}
